const React = require('react');
const { createElement: h } = React;
require('./DraftConflictBanner.css');

// A slim banner pinned to the top of the canvas when the local draft is stale:
// someone else saved a newer version of this workflow since the draft was
// taken (detected on open via the draft's baseUpdatedAt, or on save via a 409
// from the server). The user picks a side — load the latest server version
// (discarding local edits) or keep editing their draft (their next save wins).
//
//   savedAt:      string | null — server updatedAt of the newer version
//   busy:         boolean — the discard-draft refetch is in flight
//   onLoadLatest: () => void — discard the draft and refetch from the DB
//   onKeepDraft:  () => void — keep local edits; next save overwrites
function DraftConflictBanner(props) {
  var busy = !!props.busy;
  var onLoadLatest = typeof props.onLoadLatest === 'function' ? props.onLoadLatest : function() {};
  var onKeepDraft = typeof props.onKeepDraft === 'function' ? props.onKeepDraft : function() {};

  var when = '';
  if (props.savedAt) {
    try { when = ' at ' + new Date(props.savedAt).toLocaleString(); } catch (e) {}
  }

  return h('div', { className: 'draft-conflict-banner' },
    h('span', { className: 'draft-conflict-banner-badge' }, 'NEWER VERSION'),
    h('span', { className: 'draft-conflict-banner-text' },
      'This workflow was saved by someone else' + when + '. Your unsaved edits are based on an older version.'),
    h('button', {
      className: 'draft-conflict-banner-load-btn',
      onClick: onLoadLatest,
      disabled: busy,
      title: 'Discard your unsaved edits and reload the latest saved version'
    }, busy ? 'Loading…' : 'Discard draft'),
    h('button', {
      className: 'draft-conflict-banner-keep-btn',
      onClick: onKeepDraft,
      disabled: busy,
      title: 'Keep editing your draft — saving will overwrite the other version'
    }, 'Keep my draft')
  );
}

module.exports = DraftConflictBanner;
